<template>
  <div class="deviceSet">
    <div class="seats">
      <div
        :class="['seat', item ? 'seat-a' : 'seat-b']"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div v-if="item" @click="remove(index, item)" class="seat-dele"></div>
        <div v-if="item" class="seat-edit-box" @click="edit(index, item)">
          <div class="seat-edit-num">{{ item.id }}#转盘</div>
          <div class="seat-edit-count">{{ item.seatsCount }}</div>
        </div>

        <div v-else @click="add(index + 1)" class="seat-add-box">
          <div class="seat-add-label">添加转盘</div>
          <div class="seat-add-icon"></div>
        </div>
      </div>
      <div v-if="tableData.length > 0" class="next">
        <el-button @click="next" type="primary">下一步</el-button>
      </div>
    </div>

    <el-dialog title="设备信息" v-model="dialogVisible" width="50%">
      <el-form ref="form" :model="form" :rules="formRules">
        <el-form-item label="转盘位数" prop="seatsCount">
          <Keyboard v-model="form.seatsCount">
            <el-input v-model="form.seatsCount"></el-input>
          </Keyboard>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </template>
    </el-dialog>
    <Keyboard
      ref="panKeyboard"
      :isCustom="true"
      :isControl="true"
      msg="请输入数量"
      @ok="panOk"
    ></Keyboard>
  </div>
</template>

<script>
import { send } from ".././../socket/index";
import Keyboard from "@/components/keyboard/index.vue";
import { ElMessage } from "element-plus";

export default {
  name: "Page",
  components: { Keyboard },
  data() {
    return {
      dialogVisible: false,
      type: 0, //
      form: {},
      tableData: [],
      formRules: {
        seatsCount: [
          { required: true, message: "必填" },
          { type: "integer", message: "请输入整数" },
        ],
      },
    };
  },
  methods: {
    async panOk(s) {
      // console.log("panOk");
      // console.log(s);
      // console.log(this.$refs);
      // console.log(this.$refs.passwordKeyboard);
      let vs = "" + s;

      if (/^[1-9]\d*$/.test(vs)) {
        this.form.seatsCount = s;
        this.$refs.panKeyboard.isShow = false;
        if (this.type == 0) {
          try {
            let res = await this.$myRequest({
              url: "/addDeviceReq",
              method: "post",
              data: this.form,
            });
            res = res.data;
            this.getList();
            this.close();
          } catch (err) {
            console.log(err);
          }
        } else {
          try {
            let res = await this.$myRequest({
              url: "/saveDeviceReq",
              method: "post",
              data: this.form,
            });
            res = res.data;
            this.getList();
            this.close();
          } catch (err) {
            console.log(err);
          }
        }
      } else {
        ElMessage("输入错误");
      }
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.type == 0) {
            try {
              let res = await this.$myRequest({
                url: "/addDeviceReq",
                method: "post",
                data: this.form,
              });
              res = res.data;
              this.getList();
              this.close();
            } catch (err) {
              console.log(err);
            }
          } else {
            try {
              let res = await this.$myRequest({
                url: "/saveDeviceReq",
                method: "post",
                data: this.form,
              });
              res = res.data;
              this.getList();
              this.close();
            } catch (err) {
              console.log(err);
            }
          }
        } else {
          return false;
        }
      });
    },
    close() {
      this.dialogVisible = false;
      this.type = 0;
      this.form = {
        id: "",
        seatsCount: undefined,
      };
      this.$refs.form && this.$refs.form.resetFields();
    },
    edit(index, row) {
      // console.log(row);
      this.type = 1;
      this.form = JSON.parse(JSON.stringify(row));
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }

      // this.dialogVisible = true;
      this.$refs.panKeyboard.modelValueShow = "" + this.form.seatsCount;
      this.$refs.panKeyboard.isShow = true;
    },
    add(id) {
      this.type = 0;
      this.form.id = id;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }

      // this.dialogVisible = true;
      this.$refs.panKeyboard.modelValueShow = "";
      this.$refs.panKeyboard.isShow = true;
    },
    remove(i, row) {
      // console.log("dialog");
      // console.log(this);

      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            let res = await this.$myRequest({
              url: "/deleteDeviceReq",
              method: "post",
              data: {
                id: row.id,
              },
            });
            res = res.data;
            this.getList();
          } catch (err) {
            console.log(err);
          }

          // send({
          //   name: "deleteDeviceReq",
          //   data: {
          //     id: row.id,
          //   },
          // })
          //   .then((res) => {
          //     this.getList();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        })
        .catch(() => {});
    },

    async getList() {
      try {
        let res = await this.$myRequest({
          url: "/getDeviceListReq",
          method: "post",
        });
        res = res.data;
        this.tableData = res.data;
      } catch (err) {
        console.log("err form init");
        console.log(err);
      }
    },
    async next() {
      try {
        let res = await this.$myRequest({
          url: "/finishInstallingReq",
          method: "post",
        });
        res = res.data;
        this.$router.push({ path: "/" });
      } catch (err) {
        console.log("err form init");
        console.log(err);
      }

      // this.$router.push({path:'/'})
    },
  },
  mounted() {
    this.getList();
  },
};
</script>
<style scoped lang="less" src="./index.less"></style>
